/**
 * Kameras, Steuerung und Rundgang-Zustand.
 * Bewusst außerhalb von React: Diese Werte ändern sich in jedem Frame und brauchen kein Re-Rendering.
 */
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { floorBase } from "../engine/constants";

export const persp = new THREE.PerspectiveCamera(45, 1, 0.3, 250);
persp.position.set(-12, 13, 15);
export const ortho = new THREE.OrthographicCamera(-10, 10, 10, -10, 0.1, 200);
ortho.position.set(3.4, 60, -5.5); ortho.up.set(0, 0, -1); ortho.lookAt(3.4, 0, -5.5);
export const walkCam = new THREE.PerspectiveCamera(68, 1, 0.1, 250);

export const walk = { x: 5.65, y: -2.6, f: 0, yaw: 0, pitch: -0.04, keys: {} as Record<string, boolean>, jx: 0, jy: 0 };

export const rig: { orbitP: OrbitControls | null; orbitO: OrbitControls | null; dom: HTMLElement | null } = { orbitP: null, orbitO: null, dom: null };

/** Rundgang-Kamera auf den aktuellen Standort setzen (auch direkt vor dem Antippen, falls noch kein Bild gerechnet wurde) */
export function placeWalkCam() {
  walkCam.position.set(walk.x, floorBase(walk.f, walk.x, walk.y) + 1.62, -walk.y);
  walkCam.rotation.set(walk.pitch, walk.yaw, 0, "YXZ");
  walkCam.updateMatrixWorld();
}

export function attachControls(dom: HTMLElement) {
  if (rig.dom === dom) return;
  rig.orbitP?.dispose(); rig.orbitO?.dispose();
  const orbitP = new OrbitControls(persp, dom);
  orbitP.target.set(3.0, 4, -5.5); orbitP.enableDamping = true; orbitP.maxPolarAngle = Math.PI * 0.49; orbitP.minDistance = 3; orbitP.maxDistance = 70;
  const orbitO = new OrbitControls(ortho, dom);
  orbitO.enableRotate = false; orbitO.screenSpacePanning = true; orbitO.target.set(3.4, 0, -5.5);
  orbitO.mouseButtons = { LEFT: THREE.MOUSE.PAN, MIDDLE: THREE.MOUSE.DOLLY, RIGHT: THREE.MOUSE.PAN };
  orbitO.touches = { ONE: THREE.TOUCH.PAN, TWO: THREE.TOUCH.DOLLY_PAN };
  orbitO.minZoom = 0.4; orbitO.maxZoom = 8; orbitO.enabled = false;
  orbitP.update(); orbitO.update();
  Object.assign(rig, { orbitP, orbitO, dom });
}

export function resizeCameras(w: number, h: number) {
  persp.aspect = walkCam.aspect = w / h; persp.updateProjectionMatrix(); walkCam.updateProjectionMatrix();
  const half = 8.5, a = w / h;
  if (a >= 1) { ortho.left = -half * a; ortho.right = half * a; ortho.top = half; ortho.bottom = -half; }
  else { ortho.left = -half; ortho.right = half; ortho.top = half / a; ortho.bottom = -half / a; }
  ortho.updateProjectionMatrix();
}

/** Grundriss auf einen Punkt zentrieren (z. B. aus der Möbelliste) */
export function centerPlanOn(x: number, y: number) {
  rig.orbitO?.target.set(x, 0, -y); ortho.position.set(x, 60, -y);
}
